import { render, staticRenderFns } from "./ChartWidgets.vue?vue&type=template&id=70f465f2&"
import script from "./ChartWidgets.vue?vue&type=script&lang=js&"
export * from "./ChartWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports